

const Index: React.FC = () => {    
    return (
        <>
customer
        </>
    )
}

export default Index;